module.exports = __webpack_public_path__ + "static/img/3310.56bf8ebc.jpg";